"use strict";
import $ from "jquery";

export default class Carousel {
  static init() {
    $(".carousel").each((index, el) => {
      new Carousel($(el));
    });
  }

  constructor($el) {
    this.el = $($el);
    this.el.find(".carousel-slides").slick({
      dots: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            // slidesToShow: 2,
            // slidesToScroll: 2,
            infinite: false,
            arrows: true,
          },
        },
      ],
    });
  }
}
